var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_233)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_146_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5974 63.6689C49.7592 63.6689 63.6713 49.7567 63.6713 32.5949C63.6713 15.4332 49.7592 1.52051 32.5974 1.52051C15.4356 1.52051 1.52295 15.4332 1.52295 32.5949C1.52295 49.7567 15.4356 63.6689 32.5974 63.6689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5847 39.2998L50.3759 34.2236C50.605 34.0908 50.7952 33.9002 50.9275 33.6709C51.0598 33.4415 51.1295 33.1815 51.1296 32.9167V22.7648C51.1296 22.2283 50.8403 21.7269 50.3759 21.4579L41.5847 16.3817C41.3551 16.2498 41.095 16.1803 40.8303 16.1803C40.5655 16.1803 40.3054 16.2498 40.0758 16.3817L31.2846 21.4579C31.0556 21.5908 30.8655 21.7814 30.7332 22.0107C30.601 22.24 30.5312 22.5 30.5309 22.7648V40.9076L24.3655 44.4663L18.2007 40.9076V33.7881L24.3655 30.2294L28.4323 32.5767V27.8009L25.1192 25.8886C24.8898 25.7565 24.6297 25.6869 24.365 25.6869C24.1003 25.6869 23.8403 25.7565 23.6109 25.8886L14.8191 30.9653C14.59 31.098 14.3998 31.2886 14.2675 31.518C14.1353 31.7473 14.0656 32.0074 14.0654 32.2721V42.4236C14.0654 42.9605 14.3547 43.4614 14.8191 43.7304L23.6109 48.8071C23.8405 48.9386 24.1005 49.0078 24.365 49.0078C24.6296 49.0078 24.8896 48.9386 25.1192 48.8071L33.911 43.7319C34.14 43.5991 34.3301 43.4085 34.4623 43.1792C34.5946 42.9498 34.6643 42.6898 34.6647 42.4251V24.2823L34.7763 24.2188L40.8295 20.7235L46.9949 24.2823V31.4017L40.8295 34.9605L36.7693 32.6157V37.3915L40.0758 39.3013C40.3055 39.4329 40.5656 39.5021 40.8303 39.5021C41.0949 39.5021 41.355 39.4329 41.5847 39.3013V39.2998Z",
    fill: "url(#paint0_linear_146_233)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_233",
    x1: 17.2146,
    y1: 43.8106,
    x2: 49.0716,
    y2: 20.5814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A726C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#803BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3FE4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.44,
    height: 63.44,
    fill: "white",
    transform: "translate(0.877441 0.87442)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_146_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.44,
    height: 63.44,
    fill: "white",
    transform: "translate(0.877441 0.87442)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.b63eedbb16fc4eb2e464021d6eb8136b.svg";
export { ForwardRef as ReactComponent };